import styled from 'styled-components';
import { semanticColors } from 'styles/colors';
import { borderRadius, space } from 'styles/variables';
import { Button } from '@chownow/cn-web-components';

export const CardWrapper = styled.div`
  background-color: ${semanticColors.surface.primary};
  border-radius: ${borderRadius.default};
  color: ${semanticColors.content.primary};
  display: flex;
  flex-direction: column;
  margin-top: ${space.x7};
  padding: ${space.x5};
`;

export const StyledButton = styled(Button)`
  margin: 0 auto ${space.x5} auto;
`;
